import { map } from 'ramda'
import { RouteConfig } from 'vue-router'
import { addKey } from './tools'
import './plugins'

import Layout from '@/layout/Index.vue'

const routes: RouteConfig[] = [
  {
    path: '/',
    component: Layout,
    meta: { title: '我的', hidden: true },
    children: [
      {
        path: '',
        component: () => import('@/views/Home.vue'),
        meta: { title: '首页' }
      }
    ]
  },
  {
    path: '/',
    component: Layout,
    meta: { title: '系统管理', hidden: true },
    children: [
      {
        path: '',
        meta: { title: '用户管理' },
        component: () => import('@/views/Home.vue')
      },
      {
        path: '',
        meta: { title: '角色管理' },
        component: () => import('@/views/Home.vue')
      },
      {
        path: '',
        meta: { title: '权限分配' },
        component: () => import('@/views/Home.vue')
      }
    ]
  },
  {
    path: '/exam',
    component: Layout,
    meta: { title: '考试管理' },
    children: [
      {
        path: 'creater',
        meta: { title: '新建考试' },
        component: () => import('@/views/exam/Creater.vue')
      },
      {
        path: 'upload',
        meta: { title: '上传信息' },
        component: () => import('@/views/exam/Upload.vue')
      }
    ]
  },
  {
    path: '/print',
    component: Layout,
    meta: { title: '排考信息' },
    children: [
      {
        path: 'exam-download',
        meta: { title: '排考结果' },
        component: () => import('@/views/print/ExamDownload.vue')
      },
      {
        path: 'exam-profile',
        meta: { title: '考试概览' },
        component: () => import('@/views/print/ExamProfile.vue')
      },
      {
        path: 'exam-room-record',
        meta: { title: '打印考场记录' },
        component: () => import('@/views/print/ExamRecord.vue')
      },
      {
        path: 'exam-room-arrangement',
        meta: { title: '打印考场安排' },
        component: () => import('@/views/print/ExamRoomArrangement.vue')
      },
      {
        path: 'exam-room-stick',
        meta: { title: '打印考场门贴' },
        component: () => import('@/views/print/ExamRoomStick.vue')
      },
      {
        path: 'exam-room-profile',
        meta: { title: '打印考场概要' },
        component: () => import('@/views/print/ExamRoomProfile.vue')
      },
      {
        path: 'exam-seat-sticker',
        meta: { title: '打印座位贴纸' },
        component: () => import('@/views/print/ExamSeatSticker.vue')
      },
      {
        path: 'downLoadNoify',
        meta: { title: '下载监考通知' },
        component: () => import('@/views/print/downloadNotify.vue')
      }
    ]
  },
  {
    path: '/enroll-manage',
    component: Layout,
    meta: { title: '报名管理' },
    children: [
      {
        path: 'freeteacher',
        meta: { title: '免费师范生' },
        component: () => import('@/views/enroll/FreeTeacherManage.vue')
      },
      {
        path: 'art-student',
        meta: { title: '艺术类' },
        component: () => import('@/views/enroll/ArtManage.vue')
      },
      {
        path: 'upgraded-student',
        meta: { title: '专升本' },
        component: () => import('@/views/enroll/UpgradedManage.vue')
      },
      {
        path: 'taiwan-student/:id',
        meta: { title: '台湾地区入学', hidden: true },
        component: () => import('@/views/enroll/TaiwanStudentDetail.vue')
      },
      {
        path: 'taiwan-student',
        meta: { title: '台湾地区入学' },
        component: () => import('@/views/enroll/TaiwanStudentManage.vue')
      },
      {
        path: 'chongming-student',
        meta: { title: '崇明定向' },
        component: () => import('@/views/enroll/ChongmingStudentManage.vue')
      },
      {
        path: 'second-degree-student',
        meta: { title: '第二学位' },
        component: () => import('@/views/enroll/SecondDegreeStudentManage.vue')
      },
      {
        path: 'art-mail-report',
        meta: { title: '书法学邮寄登记' },
        component: () => import('@/views/enroll/ArtMailInfo.vue')
      },
      {
        path: 'others',
        meta: { title: '其他考试' },
        component: () => import('@/views/enroll/OtherManage.vue')
      },
      {
        path: 'enroll-config',
        meta: { title: '考试配置' },
        component: () => import('@/views/enroll/EnrollConfig.vue')
      }
    ]
  },
  {
    path: '/springexam',
    component: Layout,
    meta: { title: '春招考试管理' },
    children: [
      {
        path: 'exam-manage',
        meta: { title: '考试管理' },
        component: () => import('@/views/springExam/SpringExam.vue')
      },
      {
        path: 'student-manage',
        meta: { title: '学生管理' },
        component: () => import('@/views/springExam/SpringExamUser.vue')
      }
    ]
  },
  {
    path: '/mark-manage',
    component: Layout,
    meta: { title: '成绩管理' },
    children: [
      {
        path: 'upload',
        meta: { title: '上传成绩信息' },
        component: () => import('@/views/mark/UploadMarkExcel.vue')
      },
      {
        path: 'manage',
        meta: { title: '成绩信息管理' },
        component: () => import('@/views/mark/ManageMarkInfo.vue')
      },
      {
        path: 'config',
        meta: { title: '页面配置' },
        component: () => import('@/views/mark/MarkQueryConfig.vue')
      }
    ]
  },
  {
    path: '/student-photo',
    component: Layout,
    meta: { title: '新生照片管理' },
    children: [
      {
        path: 'manage',
        meta: { title: '照片管理' },
        component: () => import('@/views/studentPhoto/studentPhoto.vue')
      }
    ]
  },
  {
    path: '/login',
    meta: { public: true, hidden: true },
    component: () => import('@/views/auth/Login.vue')
  },
  {
    path: '/mark-query',
    meta: { public: true, hidden: true, title: '成绩查询' },
    component: () => import('@/views/mark/MarkQuery.vue')
  },
  {
    path: '/springexam-query',
    meta: { public: true, hidden: true, title: '春招选考试时间' },
    component: () => import('@/views/springExam/StdCheck.vue')
  },
  {
    path: '/',
    component: Layout,
    meta: { hidden: true },
    children: [
      {
        path: '401',
        meta: { title: '401' },
        component: () => import('@/views/error/401.vue')
      },
      {
        path: '*',
        alias: '404',
        meta: { title: '404' },
        component: () => import('@/views/error/404.vue')
      }
    ]
  }
]

const withKey = (map(addKey(''), routes) as any) as RouteConfig[]

export { withKey as routes }
